import styled from 'styled-components';
import {CartTableString as BaseCartTableString} from './forPages/cart/styles';

export const CartTableString = styled(BaseCartTableString)`
    grid-template-columns: 1fr auto 70px;
    text-align: left;
    gap: 15px;

    & div.mboName {
        flex-direction: column;
        align-items: flex-start;
    }

    & div.mboWorkTime {
        flex-direction: column;
        align-items: flex-start;
        min-width: 150px;
    }

    & div.mboPhone {
        padding: 0 15px;
        justify-content: center;
    }

    /* Таблица расписания — на отдельной грид-линии: колонка «Режим работы»
       не расширяется при раскрытии, ссылка «Сегодня: …» остаётся на месте.
       Правый край таблицы сажаем под ссылку раскрытия. */
    & .mboTimework {
        grid-column: 1 / -1;
        justify-content: flex-end;
        padding: 0 85px 0 20px; /* 70px колонка телефона + 15px gap */
    }

    /* Отступ от таблицы до следующей аптеки */
    &.open {
        padding-bottom: 10px;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        gap: 10px;
        & div.mboWorkTime {
            min-width: 0;   /* разрешаем колонке сжиматься — включается горизонтальный скролл таблицы */
            width: 100%;
        }
        & div.mboPhone {
            padding: 0;
            justify-content: flex-start;
        }
        & .mboTimework {
            grid-column: auto;
            justify-content: flex-start;
            padding: 0;
        }
    }
`;